import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import Input from '#components/a/form/Input'
import Plus from '#components/svg/icons/Plus'

class TaskListNewTask extends React.Component {
  render() {
    const opacityInHex = 33
    const backgroundWithOpacity = this.props.backgroundColor.concat(opacityInHex)
    return (
      <div className="tasklist__newtask">
        <Plus backgroundColor={this.props.backgroundColor} />
        <Input
          value={this.props.value}
          testid="newTask"
          onBlurHandle={this.props.onBlur ? e => this.props.onBlur(e) : undefined}
          onKeyDown={this.props.onKeyDown ? e => this.props.onKeyDown(e) : undefined}
          onChangeHandle={this.props.handleChange ? e => this.props.handleChange(e) : undefined}
          placeholder={i18n.t('aufgaben_neue_aufgabe_placeholder')}
          modifier="tasklist"
          type="text"
          style={{backgroundColor: backgroundWithOpacity}}
        />
      </div>
    )
  }
}

TaskListNewTask.propTypes = {
  value: PropTypes.string,
  handleChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  onBlur: PropTypes.func,
  backgroundColor: PropTypes.string,
}

export default TaskListNewTask
